import * as React from "react";
import "./SessionViewSlideMenu.component.css";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
export function SessionViewSlideMenu({ children, position, caption, pinned, onPinnedChanged }) {
    const [isPinned, setIsPinned] = useState(pinned !== null && pinned !== void 0 ? pinned : false);
    const menuElement = React.useRef(null);
    const { t } = useTranslation();
    useEffect(() => {
        setTimeout(() => {
            if (!menuElement.current) {
                console.error("SessionViewSlideMenu: menuElement.current is null");
                return;
            }
            menuElement.current.style.opacity = "1";
        }, 500);
    }, []);
    useEffect(() => {
        onPinnedChanged === null || onPinnedChanged === void 0 ? void 0 : onPinnedChanged(isPinned);
    }, [isPinned]);
    const getOverlayPositionClass = () => {
        return "sessionview-slide-menu-position-" + position;
    };
    const getPinButtonTooltipPosition = () => {
        switch (position) {
            case "bottom":
                return "top-right";
            case "topleft":
                return "bottom-right";
            case "topright":
                return "bottom-left";
        }
    };
    const pinButton = () => (React.createElement("div", { className: "sessionview-slide-menu-pinbutton-container" },
        React.createElement("button", { className: "icon-button-small sessionview-slide-menu-pinbutton", onClick: () => {
                setIsPinned((prev) => !prev);
            }, "data-tooltip": isPinned
                ? t("sessionview:slidemenu-button-unpin-tooltip", "Unpin this menu (Hide when mouse moves away)")
                : t("sessionview:slidemenu-button-pin-tooltip", "Pin this menu (Stay open)"), "data-tooltip-position": getPinButtonTooltipPosition() },
            React.createElement(FontAwesomeIcon, { icon: ["fas", "thumbtack"] }))));
    return (React.createElement("div", { className: `sessionview-slide-menu-hoverarea ${getOverlayPositionClass()} ${isPinned ? "sessionview-slide-menu-pinned" : ""}` },
        React.createElement("article", { className: "sessionview-slide-menu", ref: menuElement },
            !!caption && React.createElement("h2", null, caption),
            React.createElement("div", { className: "sessionview-slide-menu-content" },
                position === "topright" && pinButton(),
                children,
                position !== "topright" && pinButton()))));
}
